import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogRef } from 'app/shared/dialog';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { DataShareService } from '../../../../services/data-share.service';
import { AccountMembership, APIService, CreateEntityActionDefinitionInput, SearchableContactFilterInput, SearchableContactSortableFields, SearchableContactSortInput, SearchableSortDirection, Segment } from '../../../API.service.custom';
import { remove } from 'lodash-es'
import _ from 'lodash-es';
import { LARGE_DELETE_THRESHOLD, OFF_PEAK_HOUR_UTC } from 'globals/constants';
import { NgSelectComponent, NgLabelTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ProfileImageComponent } from '../../profile-image/profile-image.component';
import { MatButton } from '@angular/material/button';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-delete-migrate-member',
    templateUrl: './delete-migrate-member.component.html',
    styleUrls: ['./delete-migrate-member.component.scss'],
    imports: [NgSelectComponent, FormsModule, NgxIntlTelInputModule, NgLabelTemplateDirective, ProfileImageComponent, NgOptionTemplateDirective, MatButton, TitleCasePipe]
})
export class DeleteMigrateMemberComponent implements OnInit {
  action : string = null;
  memberToRemove : AccountMembership = null;
  activAccountSubscription
  activeAccount : AccountMembership = null
  allMembersSubscription;
  allMembers : AccountMembership[] = [];
  remainingMembers : AccountMembership[] = [];
  migrateToUser : AccountMembership = null;
  requestSubmitted = false;
  memberLeadCount : number = 0;
  isLargeAccount : boolean = false;
  scheduledTime : string = null;

  constructor(
    private config: DialogConfig,
    private dataService : DataShareService,
    private toastr: ToastrService,
    private api: APIService,
    private dialog: DialogRef
  ) { }

  ngOnInit(): void {
    let configData = null;
    if (this.config && this.config.data) {
      configData = this.config.data;
      this.action = configData.action;
      this.memberToRemove = configData.memberToRemove;
      if(configData.allMembers){
        this.allMembers = configData.allMembers;
        this.remainingMembers = _.cloneDeep(this.allMembers);
        if(this.memberToRemove != null && this.action == 'remove'){
          remove(this.remainingMembers, {userId: this.memberToRemove.userId});
        }
      }
      console.log("member to remove is ", this.memberToRemove);
      if(this.memberToRemove == null)
        this.toastr.error('No Member Selected');
      this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
        if (param) {
            this.activeAccount = param;
            this.fetchMemberLeadCount();
            this.allMembersSubscription = this.dataService.getAllUsersInAccount().subscribe((param_users: any) => {
              if (param_users) {
                console.log("in DeleteMigrateMemberComponent, getAllUsersInAccount is ", param_users);
                  this.allMembers = param_users;
                  this.remainingMembers = param_users;
                  if(this.memberToRemove != null){
                    remove(this.remainingMembers, {userId: this.memberToRemove.userId});
                  }
              }
            })
        }
      })
    }
  }

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
      this.activAccountSubscription.unsubscribe();
    if (this.allMembersSubscription && !this.allMembersSubscription.closed)
      this.allMembersSubscription.unsubscribe();
  }

  fetchMemberLeadCount() {
    if (this.memberToRemove && this.activeAccount) {
      let f = <SearchableContactFilterInput>{
        and: [
          { accountId: { eq: this.activeAccount.accountId } },
          { ownerId: { eq: this.memberToRemove.userId } }
        ]
      };
      let s = <SearchableContactSortInput>{
        field: SearchableContactSortableFields.updatedAt,
        direction: SearchableSortDirection.desc
      };
      this.api.SearchContacts(f, s, 1, undefined).then(event => {
        this.memberLeadCount = event.total || 0;
        if (this.memberLeadCount > LARGE_DELETE_THRESHOLD) {
          this.isLargeAccount = true;
          const now = new Date();
          const scheduled = new Date(Date.UTC(
            now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
            OFF_PEAK_HOUR_UTC, 0, 0, 0
          ));
          if (now.getTime() > scheduled.getTime()) {
            scheduled.setUTCDate(scheduled.getUTCDate() + 1);
          }
          this.scheduledTime = scheduled.toISOString();
        }
      }).catch(e => {
        console.log('Error fetching lead count for member', e);
      });
    }
  }

  submitRequest(){
    if (this.requestSubmitted) return;
    if (this.isLargeAccount) {
      const memberName = this.memberToRemove?.user?.name || 'this user';
      const actionLabel = this.action == 'remove' ? 'removal' : 'data migration';
      Swal.fire({
        title: 'Large Data Volume',
        html: `<p><strong>${memberName}</strong> owns <b style="color: red;">${this.memberLeadCount.toLocaleString()}</b> leads.</p>
               <p>To avoid disrupting daytime operations, this ${actionLabel} will be <strong>scheduled to run at 8:30 PM IST (off-peak hours)</strong>.</p>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'I Understand, Proceed',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          this.executeSubmit();
        }
      });
    } else {
      this.executeSubmit();
    }
  }

  private executeSubmit(){
        this.requestSubmitted = true;
        let input = <CreateEntityActionDefinitionInput>{}
        input.accountId = this.activeAccount.accountId;
        input.ownerId = this.activeAccount.userId;
        if(this.action == 'remove' && this.memberToRemove != null)
          input.action = "REMOVE_USER";
        else if(this.action == 'migrate' && this.memberToRemove != null)
          input.action = "REASSIGN_USER"
        let date = new Date();
        input.name = "Membership Modification " + date.toDateString();
        input.subscriptionType = "ADHOC"
        input.status = "REQUESTED"
        if (this.isLargeAccount && this.scheduledTime) {
          input.startDateTime = this.scheduledTime;
        }
        input.createdBy = this.activeAccount.userId;
        input.updatedBy = this.activeAccount.userId;
        input.segment = <Segment>{}
        let selectedFilter = {and : [{accountId :  {eq : this.activeAccount.accountId}}, {userId :  {eq : this.memberToRemove.userId}}]};
        input.segment.criteria = JSON.stringify(selectedFilter);
        input.target = JSON.stringify({userId : this.migrateToUser.userId});
        input.segment.joinStatement = "AccountMembership";
        input.segment.defaultTableName = "AccountMembership";
        this.api.CreateEntityActionDefinition(input).then(event => {
          this.requestSubmitted = false;
          console.log('Entity Action Created : ', event);
          if(this.action == 'remove')
            this.toastr.success('Delete Member Job Submitted', 'You will be notified once completed');
          else
            this.toastr.success('Data Migration Job Submitted', 'You will be notified once completed');
          this.dialog.close();
        })
          .catch(e => {
            this.requestSubmitted = false;
            console.log('Error Delete Member', e);
            this.showErrorInToastr(e, 'Error Deleting Member')
          });
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }

}
